import React from 'react';
export function Testimonials() {
  const reviews = [{
    name: 'María L.',
    text: 'Mi salvación para las tardes. Súper útil.'
  }, {
    name: 'Laura B.',
    text: 'Una excelente forma de compartir tiempo de calidad sin pantallas.'
  }, {
    name: 'Sofía R.',
    text: 'Antes terminábamos usando la TV después del trabajo. Ahora tenemos una alternativa real.'
  }, {
    name: 'Camila M.',
    text: 'Lo compré en un momento de agotamiento total y terminó siendo una de las mejores compras que hice.'
  }, {
    name: 'Carolina M.',
    text: 'Lo tengo en la tablet y solo imprimo lo que necesito.'
  }, {
    name: 'Andrea L.',
    text: 'Por fin algo práctico que realmente ayuda.'
  }, {
    name: 'Natalia F.',
    text: 'Mi hijo se concentra muchísimo más con estas actividades.'
  }, {
    name: 'Lucía T.',
    text: 'No esperaba tanto por el precio. Muy completo.'
  }, {
    name: 'Florencia V.',
    text: 'Trabajo con niños y puedo decir que las actividades están muy bien diseñadas.'
  }, {
    name: 'Mónica M.',
    text: 'Imprimí todo y lo tengo listo para usar todos los días.'
  }, {
    name: 'Ana G.',
    text: 'Encontré una nueva forma de conectar con mi hijo.'
  }, {
    name: 'Laura S.',
    text: 'Pensé que sería otro PDF más… pero lo usamos constantemente.'
  }, {
    name: 'Patricia L.',
    text: 'Solo el planner ya cambió cómo organizamos la semana.'
  }, {
    name: 'Clara L.',
    text: 'Contenido hermoso y muy útil.'
  }];
  return <section className="bg-gray-50 py-14 px-4 sm:px-6" data-id="element-228">
      <div className="max-w-5xl mx-auto space-y-8" data-id="element-229">
        <div className="text-center space-y-3" data-id="element-230">
          <span className="text-4xl block mb-2" data-id="element-231">💬</span>
          <h2 className="font-archivo text-2xl sm:text-3xl md:text-4xl uppercase text-brand-black" data-id="element-232">
            Miles de familias ya están usando "Crecer Jugando" 🌱
          </h2>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-2 sm:gap-3" data-id="element-233">
          {reviews.map((review, idx) => <div key={idx} className="bg-white p-3 rounded-lg shadow-sm border border-gray-100" data-id="element-234">
              <div className="text-brand-yellow text-xs mb-1" data-id="element-235">⭐⭐⭐⭐⭐</div>
              <p className="text-gray-700 font-medium text-xs italic mb-2 leading-snug" data-id="element-236">
                "{review.text}"
              </p>
              <p className="font-bold text-brand-black text-xs" data-id="element-237">
                {review.name}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}